/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CompanyInfoSection {

    INDUSTRY = 'INDUSTRY',

    EMPLOYEE_STRUCTURE = 'EMPLOYEE_STRUCTURE',

    HR_EMPLOYEES = 'HR_EMPLOYEES',

    CONTINGENT_WORKERS = 'CONTINGENT_WORKERS',

    OTHER_EMPLOYEES = 'OTHER_EMPLOYEES'
}

